
  document.addEventListener("DOMContentLoaded", function () {
     
    if (!document.body.classList.contains('tg-early-access')) {
    return;
  }

    if(document.body.classList.contains('template-product') && 
       document.body.classList.contains('tg-early-access')
      ) {
        const urlParams = new URLSearchParams(window.location.search);
        const accessKey = urlParams.get("access_key");
        const allowedKey = "early2025";
        if (accessKey === allowedKey) {
          // Reveal all section elements
          document.querySelectorAll("section").forEach(el => {
            el.style.display = "block";
          });
      
          document.querySelectorAll(".image-gallery").forEach(el => {
            el.style.display = "block";
          });
      
          // Also reveal any elements using the .hidden class
          document.querySelectorAll(".rm-media-earlyaccess").forEach(el => {
            el.classList.remove("hidden");
          });
        } else {
          // Remove all sections
          document.querySelectorAll("section").forEach(el => el.remove());
          document.querySelectorAll(".media-text").forEach(el => el.remove());
          // Remove gallery section
          document.querySelectorAll(".image-gallery").forEach(el => el.remove());
      
          // Remove any other hidden elements
          document.querySelectorAll(".hidden").forEach(el => el.remove());
      
          // Show access denied message
          const message = document.createElement("div");
          let product_title = product?.title;
          message.style.cssText = "text-align:center;margin:80px auto;font-size:20px;color:#333;";
          message.innerHTML = `<b>The ${product_title} is returning soon</b> <br>Keep an eye on your inbox for the upcoming release.`;
         const container = document.getElementById("MainContent");
          if (container) {
            container.appendChild(message);
          }
          document.getElementById('logo__gradient').style.setProperty('--logo-primary', '#000','important');
          document.getElementById('logo__gradient').style.setProperty('--logo-secondary', '#000','important');
        }
    }
    
  });

